<template>
  <div class="has-navbar-fixed-top">
    <nav class="navbar is-fixed-top"><SideMenu></SideMenu>
      <h1 class="title">About</h1>
    </nav>
    <section class="section">
      <div class="container">
        <div class="content">
          <p>
            <i>These Pages Fall Like Ash</i> is an immersive fiction. It’s a story told across the pages of two books - one is a crafted, physical, familiar artefact, the other is a digital text that emerges from the streets around you. The two platforms combine to produce a unique reading experience.
          </p>
        </div>
      </div>
    </section>
    <div class="hero is-dark is-bold">
      <div class="hero-body">
        <div class="container">
          <p class="is-italic mb-3">
            Imagine a world that sits alongside your own. Full of people, with wants and fears and desires just like yours. With history and culture that are very different though. This city is invisible, and it can’t be touched. It hides in plain sight, and you’d never know it was there.
          </p>
          <p class="is-italic mb-3">
            It’s not a fairy tale though, and it doesn’t live in the gaps between buildings, or under the streets. This city is as real as you want it to be.
          </p>
          <p class="is-italic">
            It’s invisible because, until today, it didn’t exist. And tomorrow it might disappear, like breath on a cold morning.
          </p>
        </div>
      </div>
    </div>
    <section class="section">
      <div class="container">
        <div class="content">
          <p>
            The experience lasts as long as you want - a few hours, a day, or a week or more. It pins itself to the world around you, responding to the place in which you find yourself. You’ll walk familiar streets and see them with new eyes. You’ll dance strangers, who will become familiar friends.
          </p>
        </div>
        <div class="content">
          <p class="subtitle">How it works:</p>
          <p>
            We send you a book, and you do the rest. You’ll need a smartphone and some fresh air, but nothing else, aside from your willingness to believe.
          </p>
        </div>
        <div class="content">
          <p class="subtitle">What do I do next?</p>
          <p>
            You can <a href="https://thesepagesfalllikeash.bigcartel.com/">buy the book here</a>. In a few days you’ll be ready to go.
          </p>
        </div>
        <div class="content">
          <p class="subtitle">What is it?</p>
          <p>
            In January 2013, Duncan Speakman, Emilie Grenier and Tom Abba sat down and made a piece of work with Neil Gaiman and Nick Harkaway
          </p>
          <p>
            You know, I’ll never get tired of typing that sentence.<sup>1</sup>
          </p>
          <p>
            That was the first edition of <i>These Pages Fall Like Ash</i>. A story told between two books, and about two worlds. About the space between them, and about two people who had lost each other, and needed to be found again. About a real city and a fictional one that exists alongside it.
          </p>
          <p>
            We made a limited run of 200 beautiful (they were, really) wooden books, and ran the whole story for three weeks in late Spring. Every book sold out within 2 days of the start, and we had some amazing responses:
          </p>
            <blockquote>
              ‘A delicious and intimate journey through realities. With my wooden book and phone in my palm I became the anchor for the finest string of spider's silk connecting me to a world that was hiding just beyond the veil.’
            </blockquote>
            <blockquote>
              ‘..feeling mildly paranoid, reading about a city you can only see out of the corner of your eye when you're not looking for it and not being quite sure what city I was in. There was a power in reading a story in those settings.’
            </blockquote>
            <blockquote>
              ‘I had my eyes opened, I paused and stories came to me. I felt calm but my mind was on fire’
            </blockquote>
          <p>
            You can’t pay for press like that.
          </p>
          <p>
            <i>These Pages</i> asked each reader to read in specific locations - you were guided around a city, experiencing the story we’d written as you stood in specific places. You read dialogue between two characters who’d forgotten the other existed, saw the reality of a city begin to crumble and never, possibly, be absolutely sure that the city you stood in wasn’t really a fiction.
          </p>
          <p>
            Then we closed it down, took the content offline, said thankyou to our readers, and began to think about how we could make it work anywhere. The thing with the first version was that it was specific to Bristol. It was an experiment in form and content, and that was necessarily constrained. The second edition, if there was going to be one, had to be site-responsive (there’s something completely delightful about knowing exactly where your reader is stood. Evoking a drowned city as they stand forty feet above a harbour), but not site-specific. We had to rewrite it so that it didn’t matter whether you were in Berlin, Brighton or Brussels; you’d get the same story, and in the same - or practically speaking, the same - places.
          </p>
          <p>
            So that’s what we did.
          </p>
          <p>
            This second edition of <i>These Pages Fall Like Ash</i> is on sale now. We’ve made a limited run of 1000. The wooden book has been replaced by a handsome softback edition that retains all the charm of the original, with some new design work and a gentle nod to the first version. It’s accompanied by a Web App. The digital layer of story - not an enhancement, but an interconnected, interdependent storytelling structure - will ask you to conjure a fictional city around your location. It’ll show you the extraordinary in the everyday. You’e welcome too, to buy a copy for a friend, or give them your copy. It’s a book, and an experience, and the two things at the same time.
          </p>
        </div>
      </div>
    </section>
    <footer class="footer is-size-7">
      <div class="container">
        <ol>
          <li>
            <p>
              It was a bit more complex than that, but nobody ever reads footnotes. Neil and Nick were creative consultants. Story wranglers. Beaters-into-shape-who-we-proceeded-to-ignore-a-bit. And we had a lot of help - see the <router-link to="/credits">Credits page</router-link>.
            </p>
          </li>
        </ol>
      </div>
    </footer>
  </div>
</template>

<script>
export default {

  name: 'About',

  components: {
  }
}
</script>

<style lang="css" scoped>
.content {
  text-align: left;
}
.hero {
  text-align: left;
}
.header {
  text-align: center;
}
.footer ol{
  counter-reset: footer-counter;
  list-style-type: none;
}
.footer li {
  counter-increment: footer-counter;
  position: relative;
  text-align: left;
}
.footer ol li::before {
  content: counter(footer-counter);
  position: absolute;
  left: -2em;
  top: -0em;
  width: 0px;
  font-size: 0.8em;
}
blockquote {
  font-style: italic;
}
.has-navbar-fixed-top {
  padding-top: 3em;
}
nav h1 {
  padding: 26px 0 10px 0;
  left: 0px;
  right: 0px;
  margin:auto;
}
</style>
